import styles from './index.module.less'
import SectionTitle from '@/pages/workshop/SectionTitle.tsx'

const Section = props => {
  const { title, extra, style } = props
  return (
    <div className={styles.section} style={style}>
      {title ? (
        <SectionTitle className={styles.sectionTitle} extra={extra}>
          {title}
        </SectionTitle>
      ) : null}
      {props.children}
    </div>
  )
}

export default Section
